var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01",
    clipPath: "url(#clip0_402_607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.56006 4.66675L7.00334 8.47704C7.44412 8.78559 7.66451 8.93986 7.90423 8.99962C8.11599 9.0524 8.33746 9.0524 8.54922 8.99962C8.78894 8.93986 9.00933 8.78559 9.45011 8.47704L14.8934 4.66675M4.76006 13.3334H11.6934C12.8135 13.3334 13.3735 13.3334 13.8014 13.1154C14.1777 12.9237 14.4837 12.6177 14.6754 12.2414C14.8934 11.8136 14.8934 11.2535 14.8934 10.1334V5.86675C14.8934 4.74664 14.8934 4.18659 14.6754 3.75877C14.4837 3.38244 14.1777 3.07648 13.8014 2.88474C13.3735 2.66675 12.8135 2.66675 11.6934 2.66675H4.76006C3.63995 2.66675 3.0799 2.66675 2.65208 2.88474C2.27575 3.07648 1.96979 3.38244 1.77805 3.75877C1.56006 4.18659 1.56006 4.74664 1.56006 5.86675V10.1334C1.56006 11.2535 1.56006 11.8136 1.77805 12.2414C1.96979 12.6177 2.27575 12.9237 2.65208 13.1154C3.0799 13.3334 3.63995 13.3334 4.76006 13.3334Z",
    stroke: "#5732AB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.226562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.19b9cecd49147bb7d6265ac352febc98.svg";
export { ForwardRef as ReactComponent };